import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Button } from "@material-ui/core";
import { buildZendeskLink } from "src/store/adminHtml/selector";
import { openZendeskWithSSO } from "src/utils/zendeskSso";
import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "src/store/system/selector";

const useStyles = makeStyles((theme) => ({
  minimalMarginBottom: {
    marginBottom: "10px",
  },
  importantText: {
    fontWeight: theme.typography.fontWeightBold,
  },
  headerText: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textField: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
}));

interface MissingFunctionalityDialogProps {
  cancellationReason: string;
  setCancellationReason: (reason: string) => void;
}

function MissingFunctionalityDialog(props: MissingFunctionalityDialogProps) {
  const classes = useStyles();
  const user = useSelector(selectUser);
  if (!user) return null;

  return (
    <div>
      <Typography variant="h4" className={classes.headerText}>
        Wait! It’s very possible My Reseller Genie does support the feature you
        need.
      </Typography>
      <Typography variant="body1">
        Let’s double-check and see if My Reseller Genie can perform the function
        you need. Click the button below to contact one of our My Reseller Genie
        functionality experts. We’ll get you the information you need in 24
        hours or less.
      </Typography>
      <div style={{ paddingTop: "1rem" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={() =>
            openZendeskWithSSO(
              buildZendeskLink(
                user,
                "MRG is missing key functionality",
                "Please use this description box to outline the functionality you wish to see in MyResellerGenie, please be as descriptive as possible:",
                "cancellationReason:missingFunctionalityAction",
                "cancelation"
              )
            )
          }
        >
          Contact Expert
        </Button>
      </div>
      <div style={{ paddingTop: "1rem" }}>
        <Typography>
          <Box component="span" fontWeight="fontWeightMedium">
            Before you click Cancel Subscription,
          </Box>{" "}
          please let us know what function or feature is missing from My
          Reseller Genie:
        </Typography>
      </div>
      <TextField
        id="filled-basic"
        label="Describe the Feature"
        variant="filled"
        className={classes.textField}
        value={props.cancellationReason}
        onChange={(event) => {
          props.setCancellationReason(event.target.value);
        }}
      />
    </div>
  );
}

export default MissingFunctionalityDialog;
